import "./NumberInputFieldlist.scss";

import { FunctionComponent, useState } from "react";
import { TextField } from "@mui/material";
import { NumberInputFieldProps } from "./INumberInputFieldPropslist";
import { Controller, useFormContext } from "react-hook-form";

const NumberInputFieldlist: FunctionComponent<NumberInputFieldProps> = (
  props
) => {
  const {
    id,
    name,
    placeholder,
    variant,
    label,
    color,
    required,
    className,
    sx,
    defaultValue,
    readOnly,
    fullWidth,
    disabledScrollBar,
    disabledScrollBarFunction,
    type = "number",
    inputClassName,
    InputProps,
    inputProps,
    inputLableStyle,
    size = "medium",
    labelSize,
    onChange,
    disabled,
  } = props;

  const [focus, setFocus] = useState(false);
  const {
    control,
    setValue,
    formState: { errors },
  } = useFormContext();

  return (
    <Controller
      name={name!}
      control={control}
      render={({ field }) => (
        <TextField
          {...field}
          value={field.value ?? ""}
          id={id}
          name={name}
          placeholder={placeholder}
          variant={variant}
          label={label}
          color={color}
          required={required}
          fullWidth={fullWidth}
          disabled={disabled}
          className={`GlobalInputStyle ${className}`}
          sx={{
            ...sx,
            "& input[type=number]": {
              "-moz-appearance": disabledScrollBar ? "textfield" : null,
            },
            "& input[type=number]::-webkit-outer-spin-button": {
              "-webkit-appearance": "none",
              margin: disabledScrollBar ? 0 : undefined,
            },
            "& input[type=number]::-webkit-inner-spin-button": {
              "-webkit-appearance": disabledScrollBar ? "none" : undefined,
              margin: disabledScrollBar ? 0 : undefined,
            },
            "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button":
            {
              display: disabledScrollBarFunction ? "none" : undefined,
            },
          }}
          error={!!errors[name!]}
          helperText={errors[name!] ? String(errors[name!]?.message) : ""}
          onFocus={() => setFocus(true)}
          onBlur={() => setFocus(false)}
          onChange={(event) => {
            const newValue = event.target.value;

            // Allow clearing
            if (newValue === "") {
              setValue(name, "", { shouldValidate: true });
              onChange?.(event);
              return;
            }

            // Allow only digits
            const isValid = /^\d*\.?\d*$/.test(newValue);
            const parsed = parseFloat(newValue);
            const max = inputProps?.max;

            if (isValid && (max === undefined || parsed <= max)) {
              setValue(name, newValue, { shouldValidate: true });
              onChange?.(event);
            }
          }}
          type={type}
          size={size}
          InputProps={{
            ...InputProps,
            readOnly,
            className: `GlobalInputPropsStyle ${inputClassName}`,
            inputMode: "numeric",
          }}
          InputLabelProps={{
            shrink: !!field.value || focus,
            size: labelSize,
            className: `GlobalInputLableStyle ${inputLableStyle}`,
          }}
          inputProps={{
            ...inputProps,
            max: inputProps?.max,
          }}
        />
      )}
    />
  );
};

export default NumberInputFieldlist;
